module.exports = __webpack_public_path__ + "BG.png?acbab99159d941e484848629de412393";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/BG.png
// module id = 333
// module chunks = 0